import {inject, Service} from '@angular/core';
import {WithApi} from '@core/classes/with-api';
import {finalize, take} from 'rxjs';
import {AnalysisService} from '@core/analysis/services/analysis.service';
import {LandModel} from '@app/features/assets-status/core/models/land-table.model';

@Service()
export class LandService extends WithApi<LandModel> {
  public analysisService = inject(AnalysisService);

  constructor() {
    super('/admin/lands');
  }

  getLandData(
    region: string,
    landId: number,
    withDemographic = false,
    next: (() => void) | null = null
  ): void {
    this.isLoading.set({...this.isLoading(), show: 'Loading'});

    this.http
      .get<any>(`${this.url}/${landId}`)
      .pipe(
        take(1),
        finalize(() => {
          setTimeout(() => {
            this.isLoading.set({...this.isLoading(), show: 'Idle'});
          }, 100);
        })
      )
      .subscribe({
        next: (response) => {
          const landName =
            response.success && response.data?.name ? response.data.name : `Land ${landId}`;
          this.analysisService.clearCache();
          this.analysisService.setCurrentSelection(region, landId, landName);
          next?.();

          if (withDemographic) {
            this.analysisService.loadDemographicAnalysisData();
          }

          this.analysisService.forceReloadData();
          this.isLoading.set({...this.isLoading(), show: 'Success'});
        },
        error: () => {
          this.analysisService.clearCache();
          this.analysisService.setCurrentSelection(region, landId, `Land ${landId}`);
          this.analysisService.forceReloadData();
          next?.();
          this.isLoading.set({...this.isLoading(), show: 'Failed'});
        },
      });
  }
}
